import { render, staticRenderFns } from "./coach-info.vue?vue&type=template&id=9238e730&lang=pug&"
import script from "./coach-info.vue?vue&type=script&lang=js&"
export * from "./coach-info.vue?vue&type=script&lang=js&"
import style0 from "./coach-info.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports